import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { MIN_LOADER_DELAY } from "../../../constants";

interface Props {
  className?: string;
  children?: any;
  fixed?: boolean;
  isLoading: boolean;
  overflow?: boolean;
}

const LoaderOverlay = ({
  className,
  children,
  fixed,
  isLoading,
  overflow = true
}: Props) => {
  const [isTimerRunning, setTimerRunning] = useState(false);

  useEffect(() => {
    if (isLoading === true) {
      setTimer();
    }
  }, [isLoading]);

  const setTimer = () => {
    setTimerRunning(true);
    setTimeout(() => {
      setTimerRunning(false);
    }, MIN_LOADER_DELAY);
  };

  return (
    <div className={classNames("loader-overlay", className)}>
      {children}
      <div
        className={classNames(
          "loader-overlay__cover",
          { active: isLoading || isTimerRunning },
          { fixed: fixed },
          { overflow: overflow }
        )}
      >
        <div className="spinner-border" role="status" />
      </div>
    </div>
  );
};

export default LoaderOverlay;
